// extracted by mini-css-extract-plugin
export default {"list_wrapper":"EditModal_list_wrapper__recfL","label":"EditModal_label__pSNb1","button_container":"EditModal_button_container__dk42w"};